import {Component, OnInit} from '@angular/core';
import {User} from "../models/user";
import {Registration} from "../models/registration";
import {AuthenticationService} from "../services/authentication.service";
import {firstValueFrom} from "rxjs";
import {ActivatedRoute} from "@angular/router";
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";
import {ConfirmationModalComponent} from "../confirmation-modal/confirmation-modal.component";

@Component({
    selector: 'app-admin-user-detail',
    templateUrl: './admin-user-detail.component.html',
    styleUrls: ['./admin-user-detail.component.css'],
    standalone: false
})
export class AdminUserDetailComponent implements OnInit {
  user!: User;
  retrievedUser!: User;
  registrations!: Registration[];

  constructor(
    public authService: AuthenticationService,
    private route: ActivatedRoute,
    private dialog: MatDialog
  ) {}

  async ngOnInit() {
    this.user = await this.authService.getUser();

    try {
      const params = await firstValueFrom(this.route.paramMap);
      const ref = params.get('id');

      if (ref != null) {
        this.authService.getUserDetails(ref).subscribe(user => {
          this.retrievedUser = user.data as User
        });
      }
    } catch (error) {
      console.error("Error occurred: ", error);
    }
  }

  /**
   * Initializes and displays the sign-up modal for the user using the sign-up modal component
   *
   */
  presentConfirmationModal(mode: string) {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.data = {
      type: mode,
      isAdmin: this.retrievedUser.admin,
      isActive: this.retrievedUser.active
    }

    const dialogRef = this.dialog.open(ConfirmationModalComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(
      data => {
        if (data.type == 'Activate') {
          this.authService.updateField(this.retrievedUser.uid, "active", !data.isActive);
          this.retrievedUser.active = !data.isActive;
        } else if (data.type == 'Admin') {
          this.authService.updateField(this.retrievedUser.uid, "admin", !data.isAdmin);
          this.retrievedUser.admin = !data.isAdmin;
        }
      }
    );
  }
}
